import { Checkbox, Input, message, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentTime } from "../../Shared/CartHelper";
import dayjs from "dayjs";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import PatientService from "../../Services/PatientService";
import { calculateAge } from "../../utils/convertionFunc";
import AddFamilyMember from "./AddFamilyMember";

function PurchaseMembership({
  handleSidePanel,
  sidePanel,
  planType,
  selectedPlan,
}) {
  const [currSelMembers, setCurrSelMembers] = useState([]);
  const [dates, setDates] = useState({ fromDate: null, toDate: null });
  const [familyMembers, setFamilyMembers] = useState([]);
  const [currSelPat, setCurrSelPat] = useState([]);
  const [loader, setLoader] = useState(false);
  const [learnMoreClicked, setLearnMoreClicked] = useState(false);
  const [newFamMemModal, setNewFamMemModal] = useState(false);
  const { patientData } = useSelector((state) => state.auth);
  const { cartData } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  console.log("selectedPlan", selectedPlan);
  console.log("cartData", cartData);

  const handleCancel = () => {
    setNewFamMemModal(false);
  };
  const handleSave = () => {
    setNewFamMemModal(false);
    handleFetchFamilyMembers();
  };

  const planLimit = selectedPlan?.totalMembersAllowed + 1 || 1;

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      if (planLimit > 1 && currSelMembers.length === 0)
        setCurrSelMembers([patientData]);
      const payload = { patientId: patientData?.patientId };
      dispatch(getCartDetails(payload));
      handleFetchFamilyMembers();
    }
  }, [patientData, planLimit, dispatch]);

  const handleFetchFamilyMembers = async () => {
    const payload = {
      parentPatientId: patientData?.patientId,
    };
    try {
      const res = await PatientService.PatientList(payload);
      setCurrSelPat([]);
      setFamilyMembers(res?.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleRadioChange = (e, record) => {
    if (e.target.checked) {
      if (currSelPat?.length >= planLimit) {
        message.error(
          `Including the primary patient, only ${planLimit} members are allowed.`
        );
        return;
      }
      setCurrSelPat((prev) => [...prev, record]);
    } else {
      setCurrSelPat((prev) =>
        prev.filter((p) => p.patientId !== record.patientId)
      );
    }
  };

  const handleAddToCart = async () => {
    if (!patientData && !patientData?.patientId) {
      message.error("Patient data not available.");
      return;
    }

    const currSelPatientIdsPayload = currSelPat?.map((item) => ({
      patientId: item.patientId,
      membershipCode: selectedPlan?.code,
    }));

    const selectedPatMemStatuses = await checkMembershipStatus(
      currSelPatientIdsPayload
    );

    const isThereAnyInvalid = selectedPatMemStatuses?.some(
      (item) => item.message === "Invalid"
    );

    if (isThereAnyInvalid) {
      const invalidPatient = selectedPatMemStatuses?.find(
        (item) => item.message === "Invalid"
      );
      const patientDetails = currSelPat?.find(
        (item) => item.patientId === invalidPatient?.patientId
      );

      message.error(
        `${patientDetails?.firstName + " " + patientDetails?.lastName} ${invalidPatient?.comment
        }`
      );
      return;
    }

    if (planLimit > 1) {
      if (currSelPat?.length === 1) {
        message.warning(`Please add at least one family member for ${selectedPlan?.description}.`);
        return;
      }
      if (currSelPat?.length > planLimit) {
        message.error(
          `${selectedPlan?.description} allows a maximum of ${planLimit} members (including the primary member).`
        );
        return;
      }
    }

    setLoader(true);
    const existingCartId = cartData?.cartId;
    const fromDateVal = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const toDateVal = dayjs().add(30, "days").format("YYYY-MM-DD HH:mm:ss");
    const totalAmount = calculateTotalAmount();
    let selectedPat = patientData;

    const totalMembers = selectedPlan?.totalMembersAllowed + 1 || 1;

    if (planLimit > 1) {
      const isPrimePatSelected = currSelPat?.some(
        (item) => item.patientId === patientData?.patientId
      );
      if (!isPrimePatSelected) {
        selectedPat = familyMembers[0];
      }
    }

    const orderDetailTemplate = (item) => ({
      accountId: selectedPat?.account_Id,
      clinicId: selectedPat?.clinic_Id,
      orderCode: item.serviceCategory,
      orderName: item.serviceName,
      orderType: "MEMBERSHIP",
      orderState: "N",
      patientId: selectedPat?.patientId,
      status: 1,
      createdBy: patientData?.patientId,
      modifiedBy: patientData?.patientId,
      createdDate: getCurrentTime(),
      modifiedDate: getCurrentTime(),
      discountPercentage: item.discountPercentage,
    });

    let payload;
    const orderHeader = {
      accountId: selectedPat?.account_Id,
      amount: totalAmount,
      cartOrderDtl:
        selectedPlan?.membershipServiceDetailsList?.map(orderDetailTemplate),
      clinicId: selectedPat?.clinic_Id,
      deliveryAddress1: selectedPat?.address1 || "",
      deliveryCity: selectedPat?.city,
      deliveryCountry: selectedPat?.country,
      deliveryState: selectedPat?.state,
      deliveryZipCode: selectedPat?.pinCode,
      discountAmount: 0,
      discountPercentage: 0,
      orderType: "MEMBERSHIP",
      paidAmount: totalAmount,
      patientId: selectedPat?.patientId,
      status: 1,
      createdDate: getCurrentTime(),
      modifiedDate: getCurrentTime(),
      membershipCode: selectedPlan?.code,
      membershipName: selectedPlan?.description,
      fromDate: fromDateVal,
      toDate: toDateVal,
      total_members: totalMembers,
    };

    const extraMembers = currSelPat?.filter(
      (item) => item.patientId !== selectedPat?.patientId
    );
    extraMembers.forEach((member, idx) => {
      const memberName = `familyMember${idx + 1}`;
      orderHeader[memberName] = member?.patientId;
    });

    if (!existingCartId) {
      payload = {
        cartOrderHdr: [orderHeader],
        cartType: 1,
        patientId: selectedPat?.patientId,
        paymentType: "",
        status: 1,
      };
    } else {
      payload = {
        ...cartData,
        cartId: existingCartId,
        modifiedDate: getCurrentTime(),
        cartOrderHdr: [...(cartData?.cartOrderHdr || []), orderHeader],
      };
    }
    setLoader(false);
    try {
      const result = await dispatch(AddtoCart(payload));
      if (result?.data) {
        const cartPayload = { patientId: patientData.patientId };
        dispatch(getCartDetails(cartPayload));
        handleSidePanel();
        setLoader(false);
        message.success("Membership added to cart successfully.");
      }
    } catch (error) {
      setLoader(false);
      console.error("Cart API error:", error);
    }
  };

  const checkMembershipStatus = async (membStatPayload) => {
    try {
      const res = await PatientService.patientMembershipStatus(membStatPayload);
      return res?.data?.data;
    } catch (e) {
      console.error(e);
    }
  };

  const handleAddFamilyMem = () => {
    setNewFamMemModal(true);
  };

  const handleCloseFamilyMem = () => {
    setNewFamMemModal(false);
  };

  const handleDateChange = (date, type) => {
    if (type === "from") {
      setDates((prevState) => ({ ...prevState, fromDate: date || null }));
    } else if (type === "to") {
      setDates((prevState) => ({ ...prevState, toDate: date || null }));
    }
  };

  const calculateMembershipMonths = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 0;

    const start = dayjs(fromDate);
    const end = dayjs(toDate);

    let months = end.diff(start, "month", true);
    months = Math.ceil(months || 1);
    return months;
  };

  const calculateTotalAmount = (from, to) => {
    if (!from || !to) return selectedPlan?.actualAmount;
    const PER_MONTH_CHARGE = selectedPlan?.actualAmount;
    const months = calculateMembershipMonths(from, to);
    const totalCharge = months * PER_MONTH_CHARGE;
    return totalCharge;
  };

  const renderCheckBox = (member) => {
    const isChecked = currSelPat?.some(
      (patient) => patient.patientId === member.patientId
    );
    const limitReached = currSelPat?.length >= planLimit;

    return (
      <Checkbox
        disabled={!isChecked && limitReached}
        checked={currSelPat?.some(
          (patient) => patient.patientId === member.patientId
        )}
        onChange={(e) => handleRadioChange(e, member)}
      />
    );
  };

  const renderFeatures = () => {
    const featuresList = selectedPlan?.membershipServiceDetailsList;
    const planFeatures = learnMoreClicked
      ? featuresList
      : featuresList?.slice(0, 2);
    return planFeatures?.map((plan, idx) => (
      <li className="flex items-center my-2" key={idx}>
        <svg
          className="w-4 h-4 mr-2 text-[#1EBBB6] flex-shrink-0"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
        {plan?.serviceName} ({plan?.serviceCategory})
      </li>
    ));
  };

  const getPlanStyles = (code) => {
    switch (code?.toUpperCase()) {
      case "SINGLE":
        return "from-[#81CAF4] to-[#58B4E9]";
      case "TWIN":
        return "from-[#5DEB6D] to-[#34CF47]";
      case "FAMILY":
        return "from-[#35D9D4] to-[#1DBBB6]";
      default:
        return "from-[#81CAF4] to-[#58B4E9]";
    }
  };

  return (
    <div className="h-full flex flex-col justify-between">
      <div className="w-full flex justify-end p-2 my-0.5 px-8">
        <button
          onClick={handleAddFamilyMem}
          className="text-[#3285D9] font-medium text-base cursor-pointer flex items-center gap-1"
        >
          <span>+</span>
          <span className="underline">Add family member</span>
        </button>
      </div>
      <div className="p-5 overflow-y-auto scrollWidth">
        <h1 className="font-inter font-medium text-base mb-4">
          Purchased membership details
        </h1>

        {/* Membership Info Header */}
        <div className="flex justify-between items-center border-2 border-[#189FAA] rounded-md p-2">
          <div>
            <div
              className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${getPlanStyles(selectedPlan?.code)}`}
            >
              <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                <span className="font-medium text-sm text-center">
                  {selectedPlan?.description.split(" ")[0]}
                </span>
                <span className="text-xs font-normal text-gray-500">
                  Membership
                </span>
              </p>
            </div>
            <div className="font-inter font-normal text-xs text-[#595959] mt-1">
              <span className="text-[#F02F2F]">*</span>
              {selectedPlan?.totalMembersAllowed === 0 ? (
                <span>Single family member only allowed</span>
              ) : selectedPlan?.totalMembersAllowed === 1 ? (
                <span>Two family members only allowed</span>
              ) : (
                <span>{selectedPlan?.totalMembersAllowed + 1} family members only allowed</span>
              )}
            </div>
          </div>

          <div className="p-2 flex flex-col items-center justify-center pr-4">
            <div>
              <span className="text-lg font-bold">
                <span className="text-sm font-normal text-gray-400 mr-0.5">
                  INR
                </span>
                {selectedPlan?.actualAmount}
              </span>
            </div>
          </div>
        </div>

        <h2 className="font-medium font-inter text-sm my-3">
          Family member details
        </h2>
        <>
          <p className="font-medium font-inter text-xs text-[#1D77ED] my-2">
            Primary member
          </p>
          {!patientData ? (
            <p>Please select a patient.</p>
          ) : (
            <div>
              <div className="border rounded-lg border-[#D7D4D4] flex items-stretch p-2 my-0.5">
                <div className="flex items-center">
                  {renderCheckBox(patientData)}
                </div>
                <div className="w-2/5 p-2 border-r-2">
                  <p className="font-inter font-medium text-base">
                    {patientData?.firstName + " " + patientData?.lastName}
                  </p>
                  <p className="font-inter font-normal text-sm text-gray-400">
                    {patientData?.patientId}
                  </p>
                </div>
                <div className="flex items-center justify-center w-1/5 p-2 border-r-2 font-inter font-normal text-sm text-[#333333] mx-2">
                  <span>
                    {patientData?.gender === "M"
                      ? "Male"
                      : patientData?.gender === "F"
                        ? "Female"
                        : ""}
                    /{calculateAge(patientData?.dob)}
                  </span>
                </div>
                <div className="w-1/3 p-2 flex items-center justify-center">
                  <p className="font-inter font-normal text-sm text-[#333333] mx-2">
                    {patientData?.mobile}
                  </p>
                </div>
              </div>
              <p className="font-medium font-inter text-xs my-2">
                Other members
              </p>
              {familyMembers?.map((member, idx) => (
                <div
                  key={idx}
                  className="border rounded-lg border-[#D7D4D4] flex items-stretch p-2 my-0.5"
                >
                  <div className="flex items-center">
                    {renderCheckBox(member)}
                  </div>
                  <div className="w-2/5 p-2 border-r-2">
                    <p className="font-inter font-medium text-base">
                      {member?.firstName + " " + member?.lastName}
                    </p>
                    <p className="font-inter font-normal text-sm text-gray-400">
                      {member?.patientId}
                    </p>
                  </div>
                  <div className="flex items-center justify-center w-1/5 p-2 border-r-2 font-inter font-normal text-sm text-[#333333] mx-2">
                    <span>
                      {member?.gender === "M"
                        ? "Male"
                        : member?.gender === "F"
                          ? "Female"
                          : ""}
                      /{calculateAge(member?.dob)}
                    </span>
                    {/* <div>&nbsp;</div> */}
                  </div>
                  <div className="w-1/3 p-2 flex items-center justify-center">
                    <p className="font-inter font-normal text-sm text-[#333333] mx-2">
                      {member?.mobile}
                    </p>
                  </div>
                </div>
              ))}
              <p className="font-medium font-inter text-sm mt-6">
                Validity Period
              </p>
              <div className="w-full flex items-center gap-2 py-2 my-0.5 font-semibold">
                {`${dayjs().format("DD/MM/YYYY")} - ${dayjs()
                  .add(1, "year")
                  .format("DD/MM/YYYY")}`}
              </div>
              <p className="font-semibold font-inter text-lg my-2">Services</p>
              <div>
                <ul className="text-sm">
                  {renderFeatures()}
                  <span
                    className="text-[#3285D9] underline cursor-pointer ml-1"
                    onClick={() => setLearnMoreClicked(!learnMoreClicked)}
                  >
                    {learnMoreClicked ? "Show less" : "Learn more"}
                  </span>
                </ul>
              </div>
            </div>
          )}
        </>
      </div>

      {/* Footer */}
      <div className="mt-auto w-full p-4 border-t flex justify-between items-center">
        <div className="flex items-center gap-2">
          <div
            className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${getPlanStyles(selectedPlan?.code)}`}
          >
            <p className="p-2 rounded-md flex flex-col justify-center bg-white">
              <span className="font-medium text-sm text-center">
                {selectedPlan?.description.split(" ")[0]}
              </span>
              <span className="text-xs font-normal text-gray-500">
                Membership
              </span>
            </p>
          </div>

          <div className="p-2 flex gap-1 items-center justify-center pr-4">
            <span className="text-lg font-bold">
              <span className="text-sm font-normal text-gray-400 mr-0.5">
                INR
              </span>
              {calculateTotalAmount()}
            </span>
          </div>
        </div>

        <button
          disabled={loader}
          onClick={handleAddToCart}
          className="bg-[#189FAA] text-white px-4 py-2 rounded-lg disabled:cursor-not-allowed disabled:opacity-50"
        >
          Add to cart
        </button>
      </div>

      {/* Add new family Member */}
      <Modal
        open={newFamMemModal}
        destroyOnClose
        footer={[]}
        title={
          <h2 className="md:text-xl text- font-bold">Add Family member</h2>
        }
        width={"70%"}
        onCancel={handleCloseFamilyMem}
      >
        <AddFamilyMember
          handleSave={handleFetchFamilyMembers}
          handleClose={handleCloseFamilyMem}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
}

export default PurchaseMembership;
